import useBreakpoint from '@/hooks/useBreakpoint';

import CabecalhoHomeMobile from './Designs/Mobile/index';
import CabecalhoHomeDesktop from './Designs/Desktop/index';
import { HeaderProps } from '@/components/atoms/Header';
import { Dispatch, SetStateAction } from 'react';

export type CabecalhoHomeProps = HeaderProps & {
  $valorInputPesquisa: string;
  $setarValorInputPesquisa: Dispatch<SetStateAction<string>>;
  $setarInputAtivo: Dispatch<SetStateAction<boolean>>;
};

export default function CabecalhoHome(props: CabecalhoHomeProps) {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <CabecalhoHomeMobile {...props} />
  ) : (
    <CabecalhoHomeDesktop {...props} />
  );
}
